var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-button',{staticClass:"buttom-notification",on:{"click":function($event){return _vm.goToNotification()}}},[_c('v-icon',{attrs:{"name":_vm.icon}}),_vm._v(" "),_vm._t("default"),_vm._v(" "),_c('small',[_vm._v(_vm._s(_vm._f("moment")(_vm.time,'from', 'now')))])],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d5f87a10","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/parts/modules/button-notification.vue
// module id = null
// module chunks = 